import { SvgIcon, SvgIconProps } from "@mui/material";

export const ExploreStatsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 64 64" fill="none">
    <rect
      xmlns="http://www.w3.org/2000/svg"
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="11.5"
      fill="#1E90FF"
      fill-opacity="0.22"
      stroke="#1E90FF"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M42 42.75H25C22.93 42.75 21.25 41.07 21.25 39V22C21.25 21.59 21.59 21.25 22 21.25C22.41 21.25 22.75 21.59 22.75 22V39C22.75 40.24 23.76 41.25 25 41.25H42C42.41 41.25 42.75 41.59 42.75 42C42.75 42.41 42.41 42.75 42 42.75Z"
      fill="#1E90FF"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M24.9998 37.7498C24.8298 37.7498 24.6498 37.6898 24.5098 37.5698C24.1998 37.2998 24.1598 36.8298 24.4298 36.5098L29.0198 31.1498C29.5198 30.5698 30.2398 30.2198 30.9998 30.1898C31.7598 30.1698 32.5098 30.4498 33.0498 30.9898L33.9998 31.9398C34.2498 32.1898 34.5798 32.3098 34.9298 32.3098C35.2798 32.2998 35.5998 32.1398 35.8298 31.8698L40.4198 26.5098C40.6898 26.1998 41.1598 26.1598 41.4798 26.4298C41.7898 26.6998 41.8298 27.1698 41.5598 27.4898L36.9698 32.8498C36.4698 33.4298 35.7498 33.7798 34.9898 33.8098C34.2298 33.8298 33.4798 33.5498 32.9398 33.0098L31.9998 32.0598C31.7498 31.8098 31.4198 31.6798 31.0698 31.6898C30.7198 31.6998 30.3998 31.8598 30.1698 32.1298L25.5798 37.4898C25.4198 37.6598 25.2098 37.7498 24.9998 37.7498Z"
      fill="#1E90FF"
    />
  </SvgIcon>
);
